module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/dice-7e14d383121a5110.jpg"+" 536w",
        images: [{path: __webpack_public_path__ + "assets/images/dice-7e14d383121a5110.jpg",width: 536,height: 560}],
        src: __webpack_public_path__ + "assets/images/dice-7e14d383121a5110.jpg",
        toString: function(){return __webpack_public_path__ + "assets/images/dice-7e14d383121a5110.jpg"},
        
        width: 536,
        height: 560
      }